module.exports = __webpack_public_path__ + "img/verification-icon.5e4c36bd.svg";